module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACASURBVDhP1ZPRCYAwDEQ7k3Glxs3sBtYNdKrUCyUgNO2HIGLhKOTlOLjSIDOvQiyFuNwlFHPA0btlLFACbI22UM0D7gGTmr256a9moSV7pcgUTzWDHQ3DPrQrf36QvLnJSKy8l7zkDwvzhqZ3zV5ZKp2recj7v6q+o7bqMLTN6QLu3Pb+pXYwewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/img/1.png
// module id = 85
// module chunks = 0